define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/breadcrumb/StateActionController",
	"csi/comm",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml/Query",
	"csi/xml"
], function(declare,lang,_,StateActionController,comm,ViewRef,locale,MessageDialog,query,xml) {

	return declare(StateActionController, {
		getActionView: function(/*ViewRef?*/vr) {
			// summary: return view to select review
			return this.inherited(arguments, [lang.mixin(new ViewRef(), {
				m_url: this.m_urlParent,
				m_id: "SizeChartReviews"
			})]);
		},

		onDependencyPaths: function(paths) {
			// summary: action requires access to all revisions
			paths.push("Child:__Parent__/Child:Revisions");
			this.inherited(arguments);
		},

		getFormData: function() {
			// summary: only allow to select one
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			fd.m_bSelectOne = true;
			return fd;
		},

         /**
         * Prompt confirmation with buttons “Confirm” and “Cancel”.
         * @param {Object} params
         */
        confirmAction: function(params) {
            params = params || {};
            params.title = this.m_action.m_name;
            params.message = locale.typeAction("SizeRange", "EvaluateFrom_Confirm");
            params.buttons = [MessageDialog.BUTTON_CONFIRM, MessageDialog.BUTTON_CANCEL];
            this.inherited(arguments);
        },

        process: function() {
            let currSizeReview = this.m_cache.getNode(this.getParent().CurrentRevision).SelectedSizes;
            let selectedSizeReview = this.m_cache.getNode(this.m_formData.getSelectedNode().ReviewSizeChart).SelectedSizes;
    	    if (!_.isEqual(currSizeReview, selectedSizeReview)) {
                this.confirmAction({});
            } else {
                this.inherited(arguments);
            }
        },

        onConfirm: function(/*String*/key) {
            if (key == "C") {
                this.postProcess();
            } else {
                StateActionController.prototype.process.call(this);
            }
        },

		preProcess: function() {
			// summary: if no reviews, then signal error
			var master = this.getParent();
			var cache = this.m_cache;

			if (_.some(master.Revisions, function(url) { return xml.isValidURL(cache.getNode(url).Review); })) {
				this.inherited(arguments);
			} else {
				this.displayErrorDialog({suffix: "_ErrorNoReview"});
			}
		},

		toWriterSelections: function(/*csi.action.FormData*/fd, /*xml.CallMethod?*/call, /*String?*/id) {
			// summary: use FromURL rather than AddURL
			this.inherited(arguments, [fd, call, xml.PROP_URL_FROM]);
		}
	});
});